import { render, staticRenderFns } from "./tjrConfigInfos.vue?vue&type=template&id=639edd13&scoped=true"
import script from "./tjrConfigInfos.vue?vue&type=script&lang=js"
export * from "./tjrConfigInfos.vue?vue&type=script&lang=js"
import style0 from "./tjrConfigInfos.vue?vue&type=style&index=0&id=639edd13&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639edd13",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('639edd13')) {
      api.createRecord('639edd13', component.options)
    } else {
      api.reload('639edd13', component.options)
    }
    module.hot.accept("./tjrConfigInfos.vue?vue&type=template&id=639edd13&scoped=true", function () {
      api.rerender('639edd13', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm/views/banquet_management/banquet_gd_details/form/components/tjrConfigInfos.vue"
export default component.exports